import { createFileRoute } from '@tanstack/react-router';
import { GamesView } from '@/components/GamesView';

export const Route = createFileRoute('/_authenticated/games')({
  component: GamesView,
});

